/* global recurly, wp101 */

(function () {
  const recurlyForms = document.querySelectorAll('.recurly-form');

  // If we don't see a Recurly form on the page, there's nothing to do.
  if (0 === recurlyForms.length) {
    return;
  }

  // The base Recurly configuration.
  const config = {
    publicKey: wp101.recurlyPublicKey,
  };

  // If we have an example input, extract its styles so Recurly-generated inputs match.
  const exampleInput = document.querySelector('input.form-control');

  // Use exampleInput as a basis for styling Recurly fields.
  if (! exampleInput) {
    window.console.warn('No example input found, Recurly inputs falling back to default styling.');

  } else {
    const styles = window.getComputedStyle(exampleInput);

    config.fields = {
      all: {
        style: {
          fontFamily: styles.fontFamily,
          fontSize: styles.fontSize,
          fontColor: styles.color,
        },
      }
    };
  }

  // Additional elements.
  const recurlyToken = document.querySelector('input[data-recurly="token"]');
  const validationErrors = document.getElementById('validation-errors');

  /**
   * Initialize Recurly.
   */
  recurly.configure(config);

  const paypal = recurly.PayPal({
    display: {
      displayName: 'WP101 Plugin',
    },
    braintree: {
      clientAuthorization: wp101.braintreeTokenizationKey,
    },
  });

  /**
   * Handle submitting a form through Recurly.js.
   *
   * This step will retrieve and set a token in `recurlyToken`.
   *
   * @param {Event} e - The form's "submit" event.
   */
  function getRecurlyToken(e) {
    const form = this;

    // If we already have a Recurly token, submit the form.
    if ('' !== recurlyToken.value) {
      form.submit();
    }

    e.preventDefault();

    recurly.token(form, function (err) {
      if (err) {
        let msg = document.createElement('li');

        msg.innerText = wp101.recurlyL10n.validationError;

        validationErrors.firstElementChild.appendChild(msg);
        validationErrors.removeAttribute('hidden');

        window.console.error(err);
      } else {
        form.submit();
      }
    });
  }

  // Click handler for PayPal buttons.
  document.getElementById('paypal-checkout').addEventListener('click', function (e) {
    paypal.start();
  });

  // Error handling for PayPal.
  paypal.on('error', function (err) {
    let msg = document.createElement('li');

      msg.innerText = wp101.recurlyL10n.paypalError;

      validationErrors.firstElementChild.appendChild(msg);
      validationErrors.removeAttribute('hidden');

      // Will be stripped out by Laravel Mix for production builds.
      window.console.error(err);
  });

  // Handle PayPal tokens.
  paypal.on('token', function (token) {
    recurlyToken.value = token.id;

    document.querySelector('.recurly-form .payment-methods').setAttribute('hidden', true);
    document.getElementById('paypal-authorized').removeAttribute('hidden');
  });

  // Register event listeners for any .recurly-form elements.
  recurlyForms.forEach(function (form) {
    form.addEventListener('submit', getRecurlyToken);
  });
}());
